import DOMPurify from 'dompurify';

const DomPurifyPlugin = {
  install(Vue) {
    Vue.prototype.$sanitize = function (html) {
      return DOMPurify.sanitize(html);
    };

    Vue.directive('safe-html', {
      bind(el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value, {
          ADD_ATTR: ['target']
        });
      },
      update(el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value, {
          ADD_ATTR: ['target']
        });
      }
    });
  }
};

export default DomPurifyPlugin;
